<template>
  <div class="app-container">

    <el-card class="mb20 mt20 ml20 mr20 ta-l" v-show="showSearch" ref="searchBox">
      <el-form :model="queryParams" ref="queryForm" size="small" :inline="true">
        <el-form-item label="购买人" prop="userName">
          <el-input
              v-model="queryParams.userName"
              placeholder="请输入购买人"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
              v-model="queryParams.phone"
              placeholder="请输入手机号"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="商品名称" prop="serviceName">
          <el-input
              v-model="queryParams.serviceName"
              placeholder="请输入商品名称"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <!--        <el-form-item label="" prop="" v-if="orgCode === '91210204341167191F'">-->
        <!--          <el-checkbox v-model="queryParams.isKq" :true-label="true" :false-label="null">刻企</el-checkbox>-->
        <!--        </el-form-item>-->
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="mb20 mt20 ml20 mr20 ta-l">
      <div>
        <div class="button-box flex-center-end" ref="buttonBox">
          <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd()">添加</el-button>
          <right-toolbar :showSearch.sync="showSearch" @queryTable="handleQuery"
                         storageKey="xxxxxxxx" @getColumns="getColumns"></right-toolbar>
        </div>
        <el-table
            v-loading="loading"
            :data="tableData"
            style="width: 100%"
            :height="getDynamicStyles(showSearch)">
          <el-table-column
              prop="userName"
              label="购买人"
              align="center">
          </el-table-column>
          <el-table-column
              prop="serviceName"
              label="商品名称"
              align="center">
          </el-table-column>
          <el-table-column
              prop="phone"
              label="手机号"
              align="center">
          </el-table-column>
          <el-table-column
              prop="createTime"
              label="起始日期"
              align="center">
            <template slot-scope="scope">
              {{ $moment(scope.row.createTime).format('YYYY-MM-DD') }}
            </template>
          </el-table-column>
          <el-table-column
              prop="expireTime"
              label="到期日期"
              align="center">
            <template slot-scope="scope">
              {{ scope.row.count ? '-' : scope.row.expireTime }}
            </template>
          </el-table-column>
          <el-table-column
              prop="count"
              label="剩余次数"
              align="center">

          </el-table-column>
        </el-table>


        <div class="pagination-container" ref="pagination">
          <pagination
              :total="total"
              :page.sync="queryParams.pageNum"
              :limit.sync="queryParams.pageSize"
              @pagination="getList"

          />
        </div>
      </div>
    </el-card>

    <add-dialog v-if="visible" :visible.sync="visible" @getList="getList"/>
  </div>
</template>

<script>
import {getDynamicStyles} from "@/utils/ruoyi";
import AddDialog from "@/pages/customerEnterprise/customerService/components/addDialog.vue";

export default {
  name: "index",
  components: {AddDialog},
  data() {
    return {
      visible: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      // 遮罩层
      loading: true,
      // 总条数
      total: 0,
      tableKey: 0,

      showSearch: true,

      tableData: [],

      sealData: [],

      statusOption: [
        {
          value: '0',
          label: '待制作'
        },
        {
          value: '1',
          label: '正常'
        },
        {
          value: '9',
          label: '注销'
        },
      ],

      payStatusOption: [
        {
          value: '0',
          label: '未付款'
        },
        {
          value: '1',
          label: '已付款'
        },
        {
          value: '9',
          label: '已退款'
        },
      ],

      makeTypeOption: [
        {
          value: 'ukey',
          label: 'k章'
        },
        {
          value: 'cloud',
          label: '云章'
        },
      ],

      isKqData: [
        {
          value: 'true',
          label: '客企'
        },
        {
          value: 'false',
          label: '印章平台'
        },
      ],

      userInfo: {},
      orgCode: ''
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleAdd() {
      this.visible = true
    },
    getDynamicStyles,
    getColumns(e) {
      this.tableKey += 1
      this.$set(this, 'columns', e)
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        isKq: null
      },
          this.handleQuery();
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList()
    },
    getList() {
      this.loading = true
      this.$http.get(this.$api.customerEnterprise.getCustomerServiceList, this.queryParams).then((res) => {
        if (res.data.code == 200) {
          let tableData = res.data.rows
          tableData.forEach((e, index) => {
            e.children = []
            e.index = index
          })
          this.tableData = tableData
          this.total = res.data.total
          this.loading = false;
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
  }
}
</script>

<style scoped lang="less">

</style>
